import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-disclosure">
          <h3 className="footer-title">Licensing & Disclosure</h3>
          <p className="footer-text">
            BSquare Financial is a marketing name. All insurance products and financial services are provided through Experior Financial Group Inc. Advisor: Paige Afanu. Licensed in Ontario. Information on this website is for general educational purposes only and does not constitute tax or legal advice. Insurance coverage, eligibility, underwriting, and pricing vary by individual circumstances and insurer requirements.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
